import Image from 'next/image';

import { cn } from '@/app/utils/cn';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';
import checkTruthyValue from '@/app/utils/checkTruthyValue';

export function CaseStudySection({ image, alt, content = [], imageRight = false, eyebrow }) {
    const gridCSS = cn(
        'grid gap-8 md:gap-16',
        checkTruthyValue(image) ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'
    );

    return (
        <div className="py-16 md:py-24">
            <div className="container">
                <div className={gridCSS}>
                    {checkTruthyValue(image) && (
                        <div
                            className={cn(
                                'relative min-h-[240px] overflow-hidden rounded-xl md:min-h-[380px]',
                                imageRight ? 'md:order-2' : 'md:order-1'
                            )}>
                            <Image
                                src={`/dA/${image}`}
                                fill
                                sizes="(max-width: 768px) calc(100vw - 32px), 50vw"
                                quality={75}
                                className="object-cover"
                                alt={alt}
                            />
                        </div>
                    )}

                    <div
                        className={cn(
                            'flex flex-col justify-center',
                            imageRight ? 'md:order-1' : 'md:order-2'
                        )}>
                        {eyebrow && (
                            <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-fuschia-400">
                                {eyebrow}
                            </p>
                        )}
                        <div className="mb-4 h-1 w-12 rounded-full bg-fuschia-600" />
                        <DotBlockEditor
                            className="prose max-w-full prose-headings:text-white prose-p:text-white prose-a:text-fuschia-300 prose-li:text-white"
                            blocks={content}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
